module.exports.lady = {
  vi: {
    title: 'Tiên nữ hồ trong Avalon: luật và kiểm tra phe',
    description:
      'Khi nào dùng Tiên nữ hồ trong Avalon, ai nhận thẻ, có thể nói dối hay không và Mordred, Kẻ lừa lọc, Kẻ gây rối xuất hiện thế nào khi bị kiểm tra.',
    keywords: ['Tiên nữ hồ trong Avalon', 'Luật chơi', 'Kiểm tra phe'],
  },
  pt: {
    title: 'Dama do Lago em Avalon: regras e lealdade',
    description:
      'Quando usar a Dama do Lago, para quem passar a ficha, se é possível mentir e como Mordred, Trickster e Troublemaker aparecem na verificação.',
    keywords: ['Dama do Lago em Avalon: regras e lealdade'],
  },
  en: {
    title: 'Lady of the Lake in Avalon: rules and loyalty checks',
    description:
      'When to use the Lady of the Lake in Avalon, who receives it, whether you can lie, and how Mordred, Trickster and Troublemaker appear in checks.',
    keywords: ['Lady of the Lake in Avalon: rules and loyalty checks'],
  },
  ru: {
    title: 'Леди Озера в Авалоне: правила и проверка лояльности',
    description:
      'Когда использовать Леди Озера, кому передавать жетон, можно ли лгать о проверке и как видны Мордред, Трикстер и Траблмейкер в Авалоне.',
    keywords: ['Леди Озера в Авалоне: правила и проверка лояльности'],
  },
  'zh-TW': {
    title: '阿瓦隆湖中仙女（湖中女神）：查驗規則與傳遞順序',
    description:
      '阿瓦隆湖中仙女何時查驗、交給誰、能否說謊？了解湖中女神的傳遞規則，以及莫德雷德、詭術師和搗蛋鬼的查驗結果。',
    keywords: ['阿瓦隆湖中仙女（湖中女神）：查驗規則與傳遞順序'],
  },
  'zh-CN': {
    title: '阿瓦隆湖中仙女（湖中女神）：查验规则与传递顺序',
    description:
      '阿瓦隆湖中仙女何时查验、交给谁、能否说谎？了解湖中女神的传递规则，以及莫德雷德、诡术师和捣蛋鬼的查验结果。',
    keywords: ['阿瓦隆湖中仙女（湖中女神）：查验规则与传递顺序'],
  },
  es: {
    title: 'Dama del Lago en Avalon: reglas y lealtad',
    description:
      'Cuándo usar la Dama del Lago, a quién pasarla, si puedes mentir y cómo aparecen Mordred, Trickster y Troublemaker al comprobar la lealtad.',
    keywords: ['Dama del Lago en Avalon: reglas y lealtad'],
  },
};
